import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { UserService } from './user.service';

@Injectable()
export class AccessGuard implements CanActivate {
  constructor(public router: Router, public userService: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return new Promise((resolve, reject) => {
      if (!this.userService.hasRole('ROLE_ADMIN')) {
        return this.userService.getProfile()
        .then((profile) => {
          if (route.params['site']) {
            return resolve(this.checkSite(profile, route.params['site']));
          }
        });
      }
      resolve(true);
    });
  }

  checkSite(profile, siteId) {
    for (let customer of profile['customers']) {
      if (customer.virtual_columns && customer.virtual_columns.user_sites) {
        for (let site of customer.virtual_columns.user_sites) {
          if (site.id === +siteId) {
            return true;
          }
        }
      }
    }
    this.router.navigate(['/403', { key: '403.site' }], { skipLocationChange: true });
    return false;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/access.guard.ts